import React from "react";

import "./textSearchBlockNitCliente.scss";

import TextSearchNitClient from "../../atoms/text/text-serach-nit-cliente/textSearchNitCliente";
const TextSearchBlockNitCliente = (Props) =>{
  return(
    <div className="TextSearchBlockNitCliente">
      <TextSearchNitClient
        ref={Props.ref}
        title={Props.title}
        type={Props.type}
        onKeyUp={Props.onKeyUp}
        value={Props.value}
        onChange={Props.onChange}
        data={Props.data}
        name={Props.name}
        placeholder={Props.placeholder}
        disabled={Props.disabled}
        digitoVerificacion={Props.digitoVerificacion}
        autoComplete={Props.autoComplete}
        label={Props.label}
      />
    </div>
  );
};

export default TextSearchBlockNitCliente;
